module.exports = __webpack_public_path__ + "media/images/emblems/Stallikon-blazon-9d49088ae1a5cc414cb07d1807b83524.svg";